import React from 'react'
import ReCAPTCHA from "react-google-recaptcha";

interface Props {
  setToken: React.Dispatch<React.SetStateAction<string | null>>
  captchaRef: React.RefObject<ReCAPTCHA>
}


export const Recaptcha = ({ setToken, captchaRef }: Props) => {

  function handleChangeCaptcha(value: string | null) {
    // the token is what the backend verifies against Google's siteverify API
    setToken(value);
  }

  return (
    <ReCAPTCHA
      // sitekey="6LcdLfMoAAAAAK0KBalcMOTGTB-P7w38jnq78n9p"
      style={{transform:'scaleX(1.0) scaleY(0.9)', margin:'0.5'}}
      ref={captchaRef}

      // passing the sirekey form .env.REACT_APP_SITE_KEY to sitekey variable
      sitekey={String(process.env.REACT_APP_SITE_KEY)}
      onChange={handleChangeCaptcha}
    />
  )
}
